import React from 'react';

const MiniCartHeaderIcon = ({toggle,orderRows}) => {
    return (
        <div className="cart has-items" onClick={() => toggle()} items={orderRows.length}>
            <a href="#"  className="mini-cart-toggle"><img src="/ui/assets/icons/bag-shopping-light.svg" alt=""/></a>
        </div>
    );
}
export default MiniCartHeaderIcon;